import styled from 'styled-components';

export const ButtonLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    color: ${({ theme }) => theme.colors.primary.white};
  }
`;

export const StyledButtonLine = styled.div`
  width: 1px;
  height: 100%;
  display: flex;
  min-height: 14px;
  background: ${({ theme }) => theme.colors.primary.white};
`;
